var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "display-ctrl", attrs: { id: "display_ctrl_footer" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "display-ctrl__btn",
          attrs: { text: "" },
          on: {
            click: function($event) {
              return _vm.$emit("trigger-display-function")
            }
          }
        },
        [
          _c("span", { staticClass: "display-ctrl__text" }, [
            _vm._v(_vm._s(_vm.$t("__map_obs.show_pic_data")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }